import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import './nearest_store.scss'

export default () => {
  return (
    <div className="nearest-store">
      <a className="store-link mb-4" href="/store-locator">
        Find Your Nearest Store<FontAwesomeIcon icon={faArrowRight} />
      </a>
      <label className="mb-4">20 stores nationwide</label>
    </div>
  )
}